/**
 * ROI Calculations
 */

const CURRENCIES = ['USD', 'CAD', 'EUR', 'GBP'];

export function selectPrices(prices, currency) {

	const cur = CURRENCIES.includes(currency) ? currency : 'USD';

	return {
		analyzer: Number(prices[`analyzer${cur}`]),
		kit: Number(prices[`kit${cur}`]),
		service: Number(prices[`service${cur}`]),
	};
}

export function calculate(inputs, prices) {
	const gxtPerMo = Number(inputs.gxtPerMo);
	const rmrPerMo = Number(inputs.rmrPerMo);
	const gxtPrice = Number(inputs.gxtPrice);
	const rmrPrice = Number(inputs.rmrPrice);
	const hourlyRate = Number(inputs.hourlyRate);
	const currency = inputs.currency || 'USD';

	const { analyzer, kit, service } = selectPrices(prices, currency);

	const totalTests = (gxtPerMo * 12) + (rmrPerMo * 12);
	const employeeCost = hourlyRate * totalTests;
	const requiredKits = Math.ceil(totalTests / 50);
	const discsLeftover = (50 * requiredKits) - totalTests;
	const y1Required = requiredKits - 1;
	const y2Required = Math.ceil((totalTests - discsLeftover) / 50);

	const revenue = (12 * gxtPerMo * gxtPrice) + (12 * rmrPerMo * rmrPrice);
	const y1Expenses = employeeCost + analyzer + (kit * (requiredKits - 1));
	const y1Profit = revenue - y1Expenses;
	const y2Expenses = employeeCost + service + (kit * y2Required);
	const y2Profit = revenue - y2Expenses;

	return {
		currency,
		totalTests,
		employeeCost,
		requiredKits,
		discsLeftover,
		y1Required,
		y2Required,
		revenue,
		y1Expenses,
		y1Profit,
		y2Expenses,
		y2Profit,
	};
}

export { CURRENCIES };
